module.exports = __webpack_public_path__ + "img/277588936.4e246e10.jpg";